export default {
  namespaced: true,
  state: {
    cascader: { value: "id", label: "name" }
  }
};
